export default __webpack_public_path__ + "static/media/Radiant@1x.1e12648d.png";